<template>
 <div class="olapic-media-wrapper">
<div id="olapic_specific_widget"></div>
</div>    
</template>

<script>
import { intersectionViewportObserver } from '@utils/intersectionViewportObserver'
    export default {
       props: {
           options: {
                type: Object,
                required: true,
                default: () => ({
                    ApiKey:'',
                    WidgetId:'',
                }),
            },
        },
       name: 'olapic',
        data: () => ({
         olapicLoaded: false
        }),

        mounted() {
          this.configureIntercectOberver()
         
        },
        methods: {
            initOlapic(change) {
                
                if (change.isIntersecting && !this.olapicLoaded ) {
                    this.olapicLoaded = true;
                    const script = document.createElement('script');
                    script.async = true;
                    script.defer = true;
                    script.src = 'https://photorankstatics-a.akamaihd.net/81b03e40475846d5883661ff57b34ece/static/frontend/latest/build.min.js';
                    script.setAttribute('data-olapic','olapic_specific_widget'); 
                    script.setAttribute('data-instance',this.options.WidgetId); 
                    script.setAttribute('data-apikey',this.options.ApiKey); 
                    document.querySelector('head').appendChild(script);
                }
            },
            configureIntercectOberver() {
            intersectionViewportObserver(this.$el, {
                checkIsVisible: false,
                callback: this.initOlapic
            })
            },
        },
    };
</script>
